<template>
  <a
    class="chat-button-link cr-flex"
    :href="link"
    tabindex="0"
    @click="handleClick"
  >
    <div class="chat-button-link__left cr-flex cr-align-center cr-justify-center">
      <BaseIcon
        :color="'var(--candy-wrapper-1000)'"
        :font-size="'var(--font-size-2)'"
        :icon="icon"
      />
    </div>
    <div class="chat-button-link__right cr-flex cr-flex-col cr-align-start cr-justify-center gap-1 spc-px-3 spc-py-1">
      <span class="chat-button-link__text label-m-medium">{{ text }}</span>
      <span class="chat-button-link__subtext label-s-regular">{{ subtext }}</span>
    </div>
  </a>
</template>

<script>
import BaseIcon from './BaseIcon.vue'

export default {
  name: 'ClientHomeChatLinkButton',
  components: {
    BaseIcon,
  },
  props: {
    link: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: 'fa-link',
    },
    text: {
      type: String,
      required: true,
    },
    subtext: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
 a {
    text-decoration: none;
    color: inherit;
 }

.chat-button-link {
  border: 1px solid var(--candy-wrapper-500);
  height: 54px;
  border-radius: 8px;
  max-width: 221px;
  min-width: 201px;
  overflow: hidden;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    border-color: var(--candy-wrapper-1000);
    box-shadow: 0px 2px 2px 1px #00000005;

    .chat-button-link__left,
    .chat-button-link__right {
      background-color: var(--candy-wrapper-200);
    }
  }

  &:active {
    .chat-button-link__left,
    .chat-button-link__right {
      background-color: var(--candy-wrapper-300);
    }
  }

  &__left {
    width: 54px;
    background-color: var(--candy-wrapper-100);
    border-right: 1px solid var(--candy-wrapper-500);

    &:active {
      background-color: var(--candy-wrapper-300);
    }
  }

  &__right {
    flex-grow: 1;
    background-color: var(--candy-wrapper-50);

    &:active {
      background-color: var(--candy-wrapper-300);
    }
  }

  &__text {
    color: var(--pepper-1000);
  }

  &__subtext {
    color: var(--pepper-1000);
  }
}
</style>
